import { createSimpleEvent, SimpleEvent } from '@passionware/simple-event';

export interface RouteChangePayload {
  pathname: string;
  search: string;
  hash: string;
  fullPath: string;
}

export const SETTINGS_RETURN_TO_KEY = 'atl.settings.returnTo';

export const routeChangeEvent: SimpleEvent<RouteChangePayload> =
  createSimpleEvent<RouteChangePayload>();

export function isSettingsPath(path: string): boolean {
  return /^\/app(?:\/[^/]+)?\/settings(?:\/|$)/.test(path);
}

export function storeLastNonSettingsPath(path: string): void {
  if (isSettingsPath(path)) {
    return;
  }
  sessionStorage.setItem(SETTINGS_RETURN_TO_KEY, path);
}

let registerLastNonSettingsPathStorageDone = false;

export function registerLastNonSettingsPathStorage() {
  if (registerLastNonSettingsPathStorageDone) {
    return;
  }
  registerLastNonSettingsPathStorageDone = true;
  routeChangeEvent.addListener(payload => {
    storeLastNonSettingsPath(payload.fullPath);
  });
}
